import React from 'react';
import cn from 'classnames';
import './Grid.css';

interface RowProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
    divided?: boolean;
    gutters?: boolean;
    align?: 'center' | 'start' | 'end';
}

export const Row = ({ divided = false, gutters = true, align, ...props }: RowProps) => {
    const className = cn('yt-row', {
        'yt-row--divided': divided,
        'yt-row--gutters': gutters,
        [`items-${align}`]: !!align,
    });
    return <div {...props} className={className} />;
};

interface ColumnProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
    xs?: number | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12';
}

export const Column = ({ xs, ...props }: ColumnProps) => {
    const className = cn('yt-column', {
        [`w-${xs}/12`]: !!xs,
    });

    return <div {...props} className={className} />;
};
